import { defineMessages } from 'react-intl';

import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.PlayerContact.ContactReach';

export const getMessages = (termLookup: SportTermLookup) => {
  const athleteTerm = termLookup[SportTerminology.ATHLETE].toLowerCase();
  const sessionTerm = termLookup[SportTerminology.SESSION].toLowerCase();
  const consequence = `This ${athleteTerm}'s family won't get report cards, ${sessionTerm} notices or any other email or text`;

  return defineMessages({
    titleNoContacts: { id: `${scope}.titleNoContacts`, defaultMessage: 'No contacts on file' },
    titleUnreachable: { id: `${scope}.titleUnreachable`, defaultMessage: 'No contact can be emailed or texted' },
    bodyNoContacts: { id: `${scope}.bodyNoContacts`, defaultMessage: `${consequence}.` },
    bodyUnreachable: {
      id: `${scope}.bodyUnreachable`,
      defaultMessage: `${consequence}: every contact is missing a valid email or phone number, or has emails and texts turned off.`,
    },
    actionEditContacts: { id: `${scope}.actionEditContacts`, defaultMessage: 'Add or fix a contact in Contacts below.' },
    actionAskConfiguration: {
      id: `${scope}.actionAskConfiguration`,
      defaultMessage: 'Someone with configuration access to this age group can add or fix a contact.',
    },
    tooltipNoContacts: {
      id: `${scope}.tooltipNoContacts`,
      defaultMessage: "No contacts on file: won't get report cards or notices",
    },
    tooltipUnreachable: {
      id: `${scope}.tooltipUnreachable`,
      defaultMessage: "No contact can be emailed or texted: won't get report cards or notices",
    },
  });
};
